import { ConnectionMaster, subscribeConnectionStatusUpdateListener as SubscribeConectionStatusUpdateListener, subscribeConnectionStatusUpdateListener, subscribeOnConnectedCancelToken, subscribeOnConnectedListener, subscribeOnDisconnectedCancelToken, subscribeOnDisconnectedForGoodCancelToken, subscribeOnDisconnectedForGoodListener, subscribeOnDisconnectedListener, subscribeOnPingHealthCancelToken, subscribeOnPingHealthListener, subscribeOnReconnectedCancelToken, subscribeOnReconnectedListener } from "../server-connection/connection-master";
import { User } from "../server-connection/login-manager";
import { AlertHistoryClient as AlertHistoryClient } from "./alert-history.client";
import { ChartDataClient } from "./chart-data.client";
import { CloudLinkClient } from "./cloud-link.client";
import { CompanyProfileClient } from "./company-profile.client";

import { HistogramClient } from "./histogram.client";
import { HolidayClient } from "./holiday.client";
import { TraceLoggingHelpers } from "./models/helpers/trace-logging-helpers";
import { StreamingAlertsClient } from "./streaming-alerts.client";
import { SymbolListClient } from "./symbol-list.client";
import { TopListHistoryClient } from "./top-list-history.client";
import { TopListClient } from "./top-list.client";

declare const window: any;

export class Connection {

    constructor() { }

    private static instance: Connection | null = null;
    
    public static getInstance(): Connection {
        if (!this.instance) {
            this.instance = new Connection();
        }

        return this.instance;
    }

    public login(username: string, password: string, applicationId: number, destination?: string, traceLogging?: boolean): Promise<User | null> {
        const currentUser = this.getCurrentUser();

        const notifyWindowLoginSubscribers = () => {
            if (window.loginSubscribers && window.loginSubscribers.length) {
                for (let i = 0; i < window.loginSubscribers.length; i++) {
                    window.loginSubscribers[i]();
                }

                window.loginSubscribers = [];
            }
        }

        if (currentUser && currentUser.username == username) {
            return new Promise<User | null>((resolve, reject) => {
                TraceLoggingHelpers.log(`User ${username} already logged in, skipping login`);

                resolve(currentUser);
            });
        } else {
            return new Promise<User | null>((resolveTest, reject) => {
                this.getConnectionMaster().login.login(username, password, applicationId, destination, traceLogging)
                    .then((user: User | null) => {
                        notifyWindowLoginSubscribers();
                        resolveTest(user);
                    })
                    .catch((errorMessage: any) => {
                        reject(errorMessage);
                    });
            });
        }

    }

    public logout() {
        this.getConnectionMaster().login.logout();
    }

    public reconnect() {
        this.getConnectionMaster().reconnect();
    }

    public subscribeConnectionStatusUpdate(listener: SubscribeConectionStatusUpdateListener) {
        this.getConnectionMaster().subscribeConnectionStatusUpdate(listener);
    }

    public isLoggedIn(): boolean {
        return this.getConnectionMaster().login.isLoggedIn();
    }

    public getCurrentUser(): User | null {
        return this.getConnectionMaster().login.getCurrentUser();
    }

    public get id(): string {
        return this.getConnectionMaster().id;
    }

    public get alertHistoryClient(): AlertHistoryClient {
        return new AlertHistoryClient();
    }

    public get chartDataClient(): ChartDataClient {
        return new ChartDataClient();
    }

    public get cloudLinkClient(): CloudLinkClient {
        return new CloudLinkClient();
    }

    public get companyProfileClient(): CompanyProfileClient {
        return new CompanyProfileClient();
    }

    public get histogramClient(): HistogramClient {
        return new HistogramClient();
    }

    public get holidayClient(): HolidayClient {
        return new HolidayClient();
    }

    public get streamingAlertsClient(): StreamingAlertsClient {
        return new StreamingAlertsClient();
    }

    public get symbolListClient(): SymbolListClient {
        return new SymbolListClient();
    }

    public get topListHistoryClient(): TopListHistoryClient {
        return new TopListHistoryClient();
    }

    public get topListClient(): TopListClient {
        return new TopListClient();
    }

    private getConnectionMaster(){
        return ConnectionMaster.primary;
    }

    public subcribeToLoginEvent(functionCall: Function) {
        const loginSubscribersDoesNotExist = !window.loginSubscribers || !window.loginSubscribers.length;
        if (loginSubscribersDoesNotExist) {
            window.loginSubscribers = [];
        }

        const alreadyLoggedIn = this.isLoggedIn();
        if (alreadyLoggedIn) {
            TraceLoggingHelpers.log(`Connection, subcribeToLoginEvent, already Logged In calling functionCall...`)
            functionCall();
        } else {
            TraceLoggingHelpers.log(`Connection, subcribeToLoginEvent, not Logged In yet, adding loginWatcher for functionCall...`)

            window.loginSubscribers.push(() => {
                functionCall();
            });
        }
    }    

    public subscribeOnConnected(listener: subscribeOnConnectedListener): subscribeOnConnectedCancelToken{
        return this.getConnectionMaster().subscribeOnConnected(listener);
    }
    
    public subscribeOnDisconnected(listener: subscribeOnDisconnectedListener): subscribeOnDisconnectedCancelToken{
        return this.getConnectionMaster().subscribeOnDisconnected(listener);
    }

    public subscribeOnReconnected(listener: subscribeOnReconnectedListener): subscribeOnReconnectedCancelToken{
        return this.getConnectionMaster().subscribeOnReconnected(listener);
    }

    public subscribeOnDisconnectedForGood(listener: subscribeOnDisconnectedForGoodListener): subscribeOnDisconnectedForGoodCancelToken{
        return this.getConnectionMaster().subscribeOnDisconnectedForGood(listener);
    }

    public subscribeOnPingHealth(listener: subscribeOnPingHealthListener): subscribeOnPingHealthCancelToken{
        return this.getConnectionMaster().subscribeOnPingHealth(listener);
    }    

}